module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += 'const test = require(\'ava\');\nconst Unknown = require(\'./UnknownClientSide.js\');\n\ntest("Check saving of unknown string", t => {\n	global.window = {parent: {thisProblem: {unknownString: "u1,41,u2,0.08211670062676699,u3,-616.21"}}};\n	const unknown = Unknown();\n	t.is(unknown.unknownString, "u1,41,u2,0.08211670062676699,u3,-616.21")\n});\n\ntest("Check splitting of unknown string", t => {\n	global.window = {parent: {thisProblem: {unknownString: "u1,41,u2,0.08211670062676699,u3,-616.21"}}};\n	const unknown = Unknown();\n	t.deepEqual(unknown.unknowns, {u1: 41, u2: 0.08211670062676699, u3: -616.21})\n});';

}
return __p
}